module.exports = __webpack_public_path__ + "img/Alternatives-Impact characterisation.2ce4d575.svg";